import { render, staticRenderFns } from "./storeEdit.vue?vue&type=template&id=4da0c367&scoped=true"
import script from "./storeEdit.vue?vue&type=script&lang=js"
export * from "./storeEdit.vue?vue&type=script&lang=js"
import style0 from "./storeEdit.vue?vue&type=style&index=0&id=4da0c367&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da0c367",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da0c367')) {
      api.createRecord('4da0c367', component.options)
    } else {
      api.reload('4da0c367', component.options)
    }
    module.hot.accept("./storeEdit.vue?vue&type=template&id=4da0c367&scoped=true", function () {
      api.rerender('4da0c367', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/components/storeEdit.vue"
export default component.exports